import { ReactNode } from "react"

import { cn } from "@/lib/cn"

type SiteHeaderProps = {
  children: ReactNode
  className?: string
}

const SiteHeader = ({ children, className }: SiteHeaderProps) => {
  return (
    <header
      className={cn(
        "sticky top-0 z-50 h-10 bg-site-header px-4 text-site-header-text shadow-[0_0.125rem_0.625rem_0_rgba(34,34,34,.04)] md:h-[3.125rem] md:px-8",
        className,
      )}
    >
      <nav className="flex h-full items-center justify-between">{children}</nav>
    </header>
  )
}

export { SiteHeader }
